// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// utils
import { fCurrency } from 'src/utils/format-number';
// types
// import { IProduct } from 'src/types/product';
// components
import Label from 'src/components/label';
import Image from 'src/components/image';
import { Typography } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  product: any;
  isRTL?: boolean;
};

export default function ProductItem({ product, isRTL }: Props) {
  const { id, name, nameAr, coverUrl, price, newLabel, saleLabel } = product;

  const linkTo = paths.product.details(id);

  const renderLabels = (newLabel?.enabled || saleLabel?.enabled) && (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ position: 'absolute', zIndex: 9, top: 16, right: 16 }}
    >
      {newLabel?.enabled && (
        <Label variant="filled" color="info">
          {newLabel.content}
        </Label>
      )}
      {saleLabel?.enabled && (
        <Label variant="filled" color="error">
          {saleLabel.content}
        </Label>
      )}
    </Stack>
  );

  const renderImg = (
    <Box sx={{ position: 'relative', p: 1 }}>
      {coverUrl ? (
        <Image alt={name} src={coverUrl} sx={{ borderRadius: 1.5 }} />
      ) : (
        <Image alt={name} src="https://placehold.co/600x800" sx={{ borderRadius: 1.5 }} />
      )}
    </Box>
  );

  const renderContent = (
    <Stack spacing={2.5} sx={{ p: 3, pt: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ position: 'relative' }}
      >
        <Link component={RouterLink} href={linkTo} color="inherit" variant="subtitle2" noWrap>
          {isRTL ? nameAr : name}
        </Link>
        <Box
          sx={{
            position: 'absolute',
            bottom: 50,
            left: -11,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.secondary',
            backgroundColor: '#eee',
            px: 1,
            py: 0.5,
            borderRadius: 1,
          }}
        >
          <Typography sx={{ fontWeight: 'bold' }}>{fCurrency(price)}</Typography>
        </Box>
      </Stack>
    </Stack>
  );

  return (
    <Card
      sx={{
        '&:hover .add-cart-btn': {
          opacity: 1,
        },
      }}
    >
      <Link component={RouterLink} href={linkTo} color="inherit" variant="subtitle2" noWrap>
        {renderLabels}

        {renderImg}

        {renderContent}
      </Link>
    </Card>
  );
}
